/* global SelfieSegmentation */

import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import bgImage from "./img/belle-photo-d-udaipur-depuis-la-fenetre-du-city-palace.jpg"
import Modal from "./Modal"
import * as faceapi from '@vladmandic/face-api'; 

// AMELIORER PROCESSS PLUS TARD OU SUPPRIMER 
const removeBackgroundAndSetWhite = async (file) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");

      // Initialiser MediaPipe
      const selfieSegmentation = new SelfieSegmentation({
        locateFile: (f) =>
          `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${f}`,
      });
      selfieSegmentation.setOptions({ modelSelection: 1 });

      selfieSegmentation.onResults((results) => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Canvas temporaire pour masque
        const maskCanvas = document.createElement("canvas");
        maskCanvas.width = canvas.width;
        maskCanvas.height = canvas.height;
        const maskCtx = maskCanvas.getContext("2d");

        maskCtx.drawImage(results.segmentationMask, 0, 0, canvas.width, canvas.height);

        const imgData = maskCtx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imgData.data;
        const threshold = 128;
        const edgeSmoothness = 30;

        for (let i = 3; i < data.length; i += 4) {
          const alpha = data[i];
          if (alpha > threshold + edgeSmoothness) {
            data[i] = 255;
          } else if (alpha < threshold) {
            data[i] = 0;
          } else {
            data[i] = ((alpha - threshold) / edgeSmoothness) * 255;
          }
        }
        maskCtx.putImageData(imgData, 0, 0);

        // Flouter le masque pour lisser les bords
        ctx.filter = "blur(2px)";
        ctx.globalCompositeOperation = "source-over";
        ctx.drawImage(maskCanvas, 0, 0, canvas.width, canvas.height);
        ctx.filter = "none";

        // Garder uniquement la personne
        ctx.globalCompositeOperation = "source-in";
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        // Fond blanc derrière
        ctx.globalCompositeOperation = "destination-over";
        ctx.fillStyle = "#FFFFFF";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Exporter l'image finale
        canvas.toBlob((blob) => {
          if (!blob) return reject("Erreur export image");
          resolve(new File([blob], file.name, { type: "image/jpeg" }));
        }, "image/jpeg", 0.9);
      });

      selfieSegmentation.send({ image: img });
    };
    img.onerror = () => reject("Erreur chargement image");
    img.src = URL.createObjectURL(file);
  });
};



// 🔄 Charger modèles FaceAPI une seule fois
const loadFaceApiModels = (async () => {
  try {
    await faceapi.nets.ssdMobilenetv1.loadFromUri('/models');
    await faceapi.nets.faceLandmark68Net.loadFromUri('/models');
    await faceapi.nets.faceRecognitionNet.loadFromUri('/models');
    console.log("✅ Modèles FaceAPI chargés (globalement)");
  } catch (err) {
    console.error("❌ Erreur chargement modèles FaceAPI:", err);
  }
})();


//Detecte visage
const detectAndCropFace = async (file) => {
  try {
    const img = await faceapi.bufferToImage(file);

    const detection = await faceapi.detectSingleFace(img).withFaceLandmarks();
    if (!detection) throw new Error("Aucun visage détecté");

    let { x, y, width, height } = detection.detection.box;

    const extraTop = height * 0.4; // cheveux
    const paddingX = width * 0.6;  
    const paddingY = height * 0.2; 

    x = Math.max(0, x - paddingX / 2);
    y = Math.max(0, y - extraTop);
    width += paddingX;
    height += paddingY + extraTop;

    // const targetWidth = 413;
    // const targetHeight = 531;
     const targetWidth = 192;
     const targetHeight = 192;

    const canvas = document.createElement('canvas');
    canvas.width = targetWidth;
    canvas.height = targetHeight;
    const ctx = canvas.getContext('2d');

    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(0, 0, targetWidth, targetHeight);

    ctx.drawImage(img, x, y, width, height, 0, 0, targetWidth, targetHeight);

    return await new Promise((resolve, reject) => {
      canvas.toBlob(blob => {
        if (!blob) reject(new Error("Erreur recadrage"));
        else resolve(new File([blob], file.name, { type: 'image/jpeg' }));
      }, 'image/jpeg', 0.9);
    });

  } catch (err) {
    throw new Error(`Erreur détection visage: ${err.message || err}`);
  }
};




//Traite l'image
const processPhoto = (file) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = () => {
      img.src = reader.result;
    };

    img.onload = () => {
      const { width, height } = img;
      if (width < 200 || height < 200) {
        reject("Photo: dimensions trop petites (<200px)");
        return;
      }

      const canvas = document.createElement('canvas');
      let targetWidth = width;
      let targetHeight = height;

      if (width > 1500 || height > 1500) {
        const ratio = width / height;
        if (width > height) {
          targetWidth = 1200;
          targetHeight = 1200 / ratio;
        } else {
          targetHeight = 1200;
          targetWidth = 1200 * ratio;
        }
      }

      canvas.width = targetWidth;
      canvas.height = targetHeight;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, targetWidth, targetHeight);



      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject("Erreur de traitement de l'image");
            return;
          }

          // Vérifie si > 500 Ko après redim
          if (blob.size > 500 * 1024) {
            canvas.toBlob(
              (compressedBlob) => {
                if (!compressedBlob) {
                  reject("Erreur de compression");
                  return;
                }
                resolve(new File([compressedBlob], file.name, { type: 'image/jpeg' }));
              },
              'image/jpeg',
              0.8
            );
          } else {
            resolve(new File([blob], file.name, { type: 'image/jpeg' }));

          }
        },
        'image/jpeg',
        0.9
      );
    };

    img.onerror = () => reject("Chargement de l'image échoué");
    reader.readAsDataURL(file);


  });

const compressImage = (file, maxWidth = 800, quality = 0.7) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const ratio = img.width / img.height;
        const width = Math.min(maxWidth, img.width);
        const height = width / ratio;
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          blob => blob ? resolve(new File([blob], file.name, { type: blob.type })) : reject("Compression failed"),
          'image/jpeg',
          quality
        );
      };
      img.onerror = () => reject("Image load error");
      img.src = URL.createObjectURL(file);
    });
  

const IdentityCard = () => {
    const [identityCards, setIdentityCards] = useState([])
    const [isDark, setIsDark] = useState(false)
    const [isMobile, setIsMobile] = useState(false)
    const [dragOver, setDragOver] = useState(false)
    const navigate = useNavigate()
    const [modal, setModal] = useState({
        show: false,
        type: 'info',
        message: '',
        autoClose: 0,
        onClose: () => {}
    })


    // Détecter si on est sur mobile
    useEffect(() => {
        const checkMobile = () => {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            const isMobileDevice = /android|iPad|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
            setIsMobile(isMobileDevice);
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Détecter le thème du navigateur
    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
        setIsDark(mediaQuery.matches)

        const handleChange = (e) => {
            setIsDark(e.matches)
        }

        mediaQuery.addEventListener('change', handleChange)
        return () => mediaQuery.removeEventListener('change', handleChange)
    }, [])

    // Charger les fichiers depuis localStorage au démarrage
    useEffect(() => {
        const savedCards = localStorage.getItem("identity-cards")
        if (savedCards) {
            try {
                const parsedData = JSON.parse(savedCards)
                setIdentityCards(parsedData)
            } catch (error) {
                console.error("Erreur lors du chargement des cartes d'identité:", error)
            }
        }
    }, [])

    const uploadFiles = () => {
        if (identityCards.length > 0) {
            // Sauvegarder dans localStorage
            localStorage.setItem("identity-cards", JSON.stringify(identityCards))
            console.log('Fichiers téléchargés:', identityCards)
            setModal({
                show: true,
                type: 'success',
                message: `Votre photo d'indentité à bien été enregistrée.`,
                autoClose: 0,
                onClose: () => {
                    setModal({ show: false })
                    navigate('/signature') // Rediriger vers la page de signature
                }
            })
        } else {
            setModal({
                show: true,
                type: 'error',
                message: "Veuillez sélectionner au moins un fichier avant de continuer.",
                autoClose: 0,
                onClose: () => setModal({ show: false })
            })
        }
    }

    const handleFileSelect = (files) => {
    Array.from(files).forEach(async file => {
        if (file.type.startsWith('image/')) {
        try {
            // 1) Traitement initial existant
            let processed = await processPhoto(file);

            // 2) Détection + crop visage
            processed = await detectAndCropFace(processed);

            // 2.5) Supprimer fond + mettre blanc
            processed = await removeBackgroundAndSetWhite(processed);

            // 3) Compression finale si besoin (poids)
            if (processed.size > 500 * 1024) {
            processed = await compressImage(processed);
            }

            // 4) Lecture et stockage
            const reader = new FileReader();
            reader.onload = () => {
            const fileData = {
                id: Date.now() + Math.random(),
                name: processed.name,
                size: processed.size,
                type: processed.type,
                data: reader.result,
                uploadedAt: new Date().toISOString()
            };
            setIdentityCards(prev => {
                const newCards = [...prev, fileData];
                localStorage.setItem("identity-cards", JSON.stringify(newCards));
                return newCards;
            });
            };
            reader.readAsDataURL(processed);

        } catch (err) {
            setModal({
            show: true,
            type: 'error',
            message: `Erreur: ${err}`,
            autoClose: 0,
            onClose: () => setModal({ show: false })
            });
        }
        }
    });
    };


    const handleIdentityCard = (e) => {
        e.preventDefault()
        const files = e.target.files
        if (files.length > 0) {
            handleFileSelect(files)
        }
    }

    const clearAll = () => {
        setIdentityCards([])
        localStorage.removeItem("identity-cards")
    }

    const handleCameraCapture = async (e) => {
        const file = e.target.files[0];
          if (file) {
            try {
              // 1) compresser
              const compressedFile = await compressImage(file);
              // 2) traiter comme d’habitude
              handleFileSelect([compressedFile]);
            } catch (err) {
              console.error("Erreur compression passport:", err);
            }
        }
    }

    const removeFile = (id) => {
        setIdentityCards(prev => {
            const updatedCards = prev.filter(file => file.id !== id)
            // Mettre à jour localStorage
            localStorage.setItem("identity-cards", JSON.stringify(updatedCards))
            return updatedCards
        })
    }

    const handleDragOver = (e) => {
        e.preventDefault()
        setDragOver(true)
    }

    const handleDragLeave = (e) => {
        e.preventDefault()
        setDragOver(false)
    }

    const handleDrop = (e) => {
        e.preventDefault()
        setDragOver(false)
        const files = e.dataTransfer.files
        if (files.length > 0) {
            handleFileSelect(files)
        }
    }

    const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 Bytes'
        const k = 1024
        const sizes = ['Bytes', 'KB', 'MB', 'GB']
        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    }

    const themeClasses = isDark ? {
        background: "min-h-screen bg-cover bg-center bg-no-repeat relative",
        backgroundImage: bgImage,
        overlay: "absolute inset-0 bg-black/60 backdrop-blur-sm",
        card: "bg-slate-800/95 backdrop-blur-xl border-slate-700/50",
        header: "bg-gradient-to-r from-orange-600 to-green-600",
        text: "text-slate-200",
        textMuted: "text-slate-400",
        textLight: "text-slate-300",
        uploadArea: dragOver ? "border-orange-400 bg-orange-900/40" : "border-slate-600 hover:border-orange-400 hover:bg-orange-900/20",
        uploadIcon: "bg-slate-700 text-slate-400 group-hover:bg-orange-700 group-hover:text-orange-300",
        button: "bg-gradient-to-r from-orange-600 to-green-600 hover:from-orange-700 hover:to-green-700 shadow-lg shadow-orange-500/25",
        cameraButton: "bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 shadow-lg shadow-green-500/25",
        clearButton: "bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700",
        security: "text-slate-300",
        fileCard: "bg-slate-700/50 border-slate-600/50 hover:bg-slate-700/70"
    } : {
        background: "min-h-screen bg-cover bg-center bg-no-repeat relative",
        backgroundImage: bgImage,
        overlay: "absolute inset-0 bg-white/70 backdrop-blur-sm",
        card: "bg-white/90 backdrop-blur-xl border-white/50",
        header: "bg-gradient-to-r from-orange-600 to-green-600",
        text: "text-slate-700",
        textMuted: "text-slate-500",
        textLight: "text-slate-600",
        uploadArea: dragOver ? "border-orange-400 bg-orange-50/80" : "border-slate-300 hover:border-orange-400 hover:bg-orange-50/80",
        uploadIcon: "bg-white/80 text-slate-500 group-hover:bg-orange-100 group-hover:text-orange-600",
        button: "bg-gradient-to-r from-orange-600 to-green-600 hover:from-orange-700 hover:to-green-700 shadow-lg shadow-orange-500/20",
        cameraButton: "bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 shadow-lg shadow-green-500/20",
        clearButton: "bg-gradient-to-r from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600",
        security: "text-slate-600",
        fileCard: "bg-white/70 border-white/50 hover:bg-white/80"
    }

    return (
        <>
        <div 
            className={themeClasses.background}
            style={{ backgroundImage: `url(${themeClasses.backgroundImage})` }}
        >
        <div className={`${themeClasses.background} flex items-center justify-center p-4 min-h-screen`}>
            <div className="w-full max-w-2xl">
                <div className={`${themeClasses.card} rounded-3xl shadow-2xl overflow-hidden border`}>
                    <div className={`${themeClasses.header} px-8 py-6 relative overflow-hidden`}>
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent transform -skew-x-12"></div>
                        <div className="relative z-10">
                            <div className="flex items-center justify-center mb-4">
                                <div className="w-14 h-14 bg-white/20 rounded-2xl flex items-center justify-center backdrop-blur-sm">
                                    <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                                    </svg>
                                </div>
                            </div>
                            <h2 className="text-2xl font-bold text-white text-center leading-tight">
                                Veuillez insérer une photos d'identité ou scan de votre photo d'identité <br /><br /> (La photo ou le scan doit être de bonne qualité)
                            </h2>
                        </div>
                    </div>

                    <div className="p-8">
                        <div className="mb-8">

                            <div 
                                className="relative mb-6"
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                onDrop={handleDrop}
                            >
                                <input 
                                    onChange={handleIdentityCard} 
                                    type="file"
                                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                                    accept=".jpg,.jpeg,.png"
                                    multiple
                                />
                                <div 
                                    className={`border-3 border-dashed ${themeClasses.uploadArea} rounded-2xl p-10 text-center transition-all duration-300 group`}
                                    onDrop={handleDrop}
                                    onDragOver={handleDragOver}
                                    onDragLeave={handleDragLeave}
                                >
                                    <div className="flex flex-col items-center">
                                        <div className={`w-20 h-20 ${themeClasses.uploadIcon} rounded-2xl flex items-center justify-center mb-6 transition-all duration-300 group-hover:scale-110`}>
                                            <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                            </svg>
                                        </div>
                                        <p className={`${themeClasses.textLight} font-semibold text-lg mb-2`}>
                                            Cliquez pour sélectionner
                                        </p>
                                        <p className={`${themeClasses.textMuted} mb-4`}>
                                            ou glissez-déposez vos fichiers ici
                                        </p>
                                        <div className={`px-4 py-2 rounded-full bg-gradient-to-r from-orange-500/20 to-green-500/20 text-sm ${themeClasses.textMuted} border border-purple-200/30`}>
                                            JPG, PNG • Plusieurs fichiers acceptés
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Bouton caméra pour mobile */}
                            {isMobile && (
                                <div className="mb-6">
                                    <div className={`text-center text-sm ${themeClasses.textMuted} mb-4 flex items-center justify-center gap-3`}>
                                        <div className="flex-1 h-px bg-gradient-to-r from-transparent to-gray-300"></div>
                                        <span className="px-3">ou</span>
                                        <div className="flex-1 h-px bg-gradient-to-l from-transparent to-gray-300"></div>
                                    </div>
                                    <div className="relative group">
                                        <input 
                                            onChange={handleCameraCapture}
                                            type="file"
                                            accept="image/*"
                                            capture="environment"
                                            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                                        />
                                        <button className={`w-full ${themeClasses.cameraButton} text-white font-semibold py-4 px-6 rounded-2xl transition-all duration-300 transform hover:scale-[1.02] hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-emerald-200/50 group-hover:shadow-emerald-500/25`}>
                                            <span className="flex items-center justify-center gap-3">
                                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                                                </svg>
                                                Prendre une photo
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* Liste des fichiers téléchargés */}
                            {identityCards.length > 0 && (
                                <div className="mb-6">
                                    <div className="flex items-center justify-between mb-4">
                                        <h3 className={`text-lg font-semibold ${themeClasses.text}`}>
                                            Fichiers sélectionnés ({identityCards.length})
                                        </h3>
                                        <button
                                            onClick={clearAll}
                                            className={`text-sm px-3 py-1 ${themeClasses.clearButton} text-white rounded-lg transition-all duration-200 hover:scale-105`}
                                        >
                                            Tout supprimer
                                        </button>
                                    </div>
                                    <div className="space-y-3 max-h-60 overflow-y-auto">
                                        {identityCards.map((passport) => (
                                            <div key={passport.id} className={`${themeClasses.fileCard} border rounded-xl p-4 transition-all duration-200`}>
                                                <div className="flex items-center gap-4">
                                                    <div className="w-12 h-12 rounded-lg overflow-hidden bg-gradient-to-br from-purple-500 to-blue-500 flex-shrink-0">
                                                        <img 
                                                            src={passport.data} 
                                                            alt={passport.name}
                                                            className="w-full h-full object-cover"
                                                        />
                                                    </div>
                                                    <div className="flex-1 min-w-0">
                                                        <p className={`font-medium ${themeClasses.text} truncate`}>
                                                            {passport.name}
                                                        </p>
                                                        <p className={`text-sm ${themeClasses.textMuted}`}>
                                                            {formatFileSize(passport.size)}
                                                        </p>
                                                    </div>
                                                    <button
                                                        onClick={() => removeFile(passport.id)}
                                                        className="w-8 h-8 rounded-full bg-red-500/20 text-red-500 hover:bg-red-500/30 transition-colors flex items-center justify-center flex-shrink-0"
                                                    >
                                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                        <button
                            onClick={uploadFiles}
                            disabled={identityCards.length === 0}
                            className={`w-full ${themeClasses.button} text-white font-semibold py-4 px-6 rounded-xl transition-all duration-300 transform hover:scale-[1.02] focus:outline-none focus:ring-4 focus:ring-purple-200/50 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none`}
                        >
                            <span className="flex items-center justify-center gap-3">
                                <span>Continuer </span>
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                                </svg>
                            </span>
                        </button>
                    </div>
                </div>

                <div className="mt-8 text-center">
                    <div className={`inline-flex items-center gap-3 px-6 py-3 ${themeClasses.fileCard} rounded-full border backdrop-blur-sm`}>
                        <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                        </svg>
                        <span className={`text-sm font-medium ${themeClasses.security}`}>
                            Vos documents sont stockés localement et sécurisés
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
        {modal.show && (
            <Modal 
                type={modal.type}
                message={modal.message}
                onClose={modal.onClose}
                autoClose={modal.autoClose}
            />
        )}
    </>
    )
}

export default IdentityCard